import { MDBCheckbox, MDBDatatable, MDBRadio, MDBSelect } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";



function WeelySchedule(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const basicData = {
        columns: ['Name', 'Position', 'Remove'],
        rows: [
            ['4th of July', 'From: 07/04/2023 12:00 AM To: 07/04/2023 11:59 PM', <i className="fas fa-xmark text-primary text-end" alt="Profile" ></i>],
            ['Christmas', 'From: 12/24/2023 12:00 AM To: 12/26/2023 11:59 PM', <i className="fas fa-xmark text-primary text-end" alt="Profile" ></i>]

        ]
    };
    return (

        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body tablinks={2}
                    content={
                        <>
                            <section>
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            <strong>{t('WeeklySchedule')}</strong>
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className="mt-2 ">
                                            <MDBRadio name='inlineRadio' id='inlineRadio1' value='option1' label='24/7' inline />
                                            <MDBRadio name='inlineRadio' id='inlineRadio2' value='option2' label='Weekly Schedule' inline />
                                        </div>

                                        <div className="row ms-0">
                                            <div className="w-100">
                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('sunday')}
                                                    </div>
                                                    <div className="w-30 d-none col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 d-none pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Default checkbox' />
                                                    </div>
                                                </div>

                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('monday')}
                                                    </div>
                                                    <div className="w-30 d-flex col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                    </div>
                                                </div>

                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('tuesday')}
                                                    </div>
                                                    <div className="w-30 d-flex col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                    </div>
                                                </div>

                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('wednesday')}
                                                    </div>
                                                    <div className="w-30 d-flex col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                    </div>
                                                </div>

                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('thursday')}
                                                    </div>
                                                    <div className="w-30 d-flex col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                    </div>
                                                </div>

                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('friday')}
                                                    </div>
                                                    <div className="w-30 d-flex col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                    </div>
                                                </div>

                                                <div className="pt-3 row">
                                                    <div className="col-3">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        {t('saturday')}
                                                    </div>
                                                    <div className="w-30 d-none col-7">
                                                        <label className="px-2 pt-2">{t('from')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                                { text: "9:00 AM", value: 1 },
                                                            ]}
                                                        />
                                                        <label className="px-2 pt-2">{t('to')}</label>
                                                        <MDBSelect

                                                            data={[
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                                { text: "6:00 PM", value: 1 },
                                                            ]}
                                                        />

                                                    </div>
                                                    <div className="col-2 d-none pt-1">
                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="routing-border mt-3"></div>
                                        <div className="card-header d-flex justify-content-between border-0">
                                            <h5 className="mb-0 ">
                                                <strong>{t('Holidays')}</strong>
                                            </h5>
                                            <div className="add-number floatRight" data-bs-toggle="modal" data-bs-target="#addnumber">+ {t('PurchaseQueues')}</div>
                                        </div>
                                        <MDBDatatable data={basicData} sortField="Name" />
                                    </div>
                                </div>
                            </section>
                        </>
                    }
                />
                {/* <Footer /> */}
            </>
        </React.Fragment >

    );
}

export default WeelySchedule;
